import script from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"

import "./ContactInformation.vue?vue&type=style&index=0&id=1c70229a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c70229a"]])

export default __exports__